import styled, { css } from 'styled-components';
import { variables } from '@splunk/themes';
import RadioList from '@splunk/react-ui/RadioList';
import { ControlGroup } from '../ControlGroup';

type RadioInputGridProps = {
    $maxLabelWidth?: string | number;
};

export type StyledOptionProps = {
    $hasControl: boolean;
    $row: number;
};

export type StyledNestedControlProps = {
    $row: number;
};

export const RadioInputGrid = styled.div<RadioInputGridProps>`
    display: grid;
    grid-template-columns:
        [input] min-content [input-end label] fit-content(
            ${(props) => props.$maxLabelWidth ?? '20ch'}
        )
        [label-end control] 1fr;
    gap: ${variables.spacingMedium} ${variables.spacingSmall};
    align-items: center;
    width: 100%;

    // This makes assumptions about the DOM structure of ControlGroup. Sad.
    & > ${ControlGroup} {
        display: contents;

        & > :first-child,
        & > :not(:first-child) > :not(:first-child) {
            // Span the ControlGroup label, help, and error across all columns
            grid-column: 1 / -1;
        }

        & > :not(:first-child),
        & > :not(:first-child) > :first-child {
            // Flatten the RadioList radio options and their labels into the grid
            display: contents;
        }
    }
`;

export const StyledRadioList = styled(RadioList)`
    // Override the SUI RadioList display from grid to contents so we can interweave nested controls
    && {
        display: contents;
    }
`;

export const StyledOption = styled(RadioList.Option)<StyledOptionProps>`
    && {
        grid-column: input / label-end;
        grid-row: ${(props) => props.$row};
        display: grid;
        grid-template-columns: subgrid;
        align-items: center;
        align-self: baseline;

        ${(props) =>
            props.$hasControl &&
            css`
                min-height: ${variables.inputHeight};
            `}
    }
`;

export const StyledNestedControl = styled.div<StyledNestedControlProps>`
    grid-column: 3;
    grid-row: ${(props) => props.$row};
    min-width: 0;
    width: 100%;

    &:empty {
        display: none;
    }

    // This probably isn't needed because of the styles UDF already adds but it prevents
    // future changes to that styled ControlGroup from adding extra spacing to this layout
    & > ${ControlGroup} {
        margin-bottom: 0;
        width: 100%;
    }
`;
